import Cookies from 'universal-cookie';

export interface ISendFacebookEventPayload {
    event: string;
    eventID: string;
    uid: string;
    data: {
        [key: string]: string | number | null;
    };
}

export const FB_EVENTS = {
    PAYMENT_DEPOSIT: 'Purchase', // + Purchase - PURCHASE - event_id: deposit_completed_{uid} - успешный депозит
    PAYMENT_DEPOSIT_CREATED: 'AddPaymentInfo', // + AddPaymentInfo - ADD_PAYMENT_INFO - event_id: deposit_created_{uid} - создание депозита
    PAYMENT_OPEN: 'AddToCart', // + AddToCart - ADD_TO_CART - event_id: deposit_open_{uid} - открыли окно депозита
    SIGNUP: 'CompleteRegistration', // + CompleteRegistration - COMPLETE_REGISTRATION - event_id: {fingeprint} завершение реги
    TRADING_DEMO_DEAL: 'StartTrial', // + StartTrial - START_TRIAL - event_id: position_open_{uid} - открыли позицию (демо или реал)
    VIEW_CONTENT: 'ViewContent', // + ViewContent - VIEW_CONTENT - event_id: select_real_account_{uid} - переход на реальный счет
}

const sendFacebookEvent = async (payload: ISendFacebookEventPayload) => {
    try {
        if (window.fbq) {
            const cookies = new Cookies();
            const fbc = cookies.get('_fbc');
            const fbp = cookies.get('_fbp');

            window.fbq('track', payload.event, payload.data, {
                eventID: payload.eventID,
                fbc,
                fbp,
                external_id: payload.uid,
            });
        }
    } catch (e) {
    }
}

export default sendFacebookEvent;
